import type { StateCreator } from 'zustand'

export interface ITenantCustomRolesValues {
  enabling?: boolean
  [key: string]: unknown
}

export interface TenantCustomRolesSlice {
  tenantCustomRolesValues: ITenantCustomRolesValues | null
  tenantCustomRolesLoaded: boolean
  tenantCustomRolesTenantId?: string
  setTenantCustomRolesValues: (tenantCustomRolesValues: ITenantCustomRolesValues | null) => void
  setTenantCustomRolesLoaded: (tenantCustomRolesLoaded: boolean) => void
  setTenantCustomRolesTenantId: (tenantCustomRolesTenantId?: string) => void
  clearTenantCustomRolesCache: () => void
}

export const createTenantCustomRolesSlice: StateCreator<
  TenantCustomRolesSlice,
  [],
  [],
  TenantCustomRolesSlice
> = (set: Function) => ({
  tenantCustomRolesValues: null,
  tenantCustomRolesLoaded: false,
  tenantCustomRolesTenantId: undefined,
  setTenantCustomRolesValues: (tenantCustomRolesValues: ITenantCustomRolesValues | null) =>
    set({ tenantCustomRolesValues }),
  setTenantCustomRolesLoaded: (tenantCustomRolesLoaded: boolean) =>
    set({ tenantCustomRolesLoaded }),
  setTenantCustomRolesTenantId: (tenantCustomRolesTenantId?: string) =>
    set({ tenantCustomRolesTenantId }),
  clearTenantCustomRolesCache: () =>
    set({
      tenantCustomRolesValues: null,
      tenantCustomRolesLoaded: false,
      tenantCustomRolesTenantId: undefined
    })
})
